import React from "react"
import Image from "../components/image"
import { Container, Row, Col } from "react-bootstrap"
import { graphql } from "gatsby"

const StandardPage = ({title, images, html}) => {
  const results = [];
  for (const [index, { node }] of images.edges.entries()) {
    results.push(<Col sm={6} key={index}><Image fluid={node.childImageSharp.fluid} /></Col>)
  }
  return (
    <>
      <Container className="pt-5">
        <h2 className="my-4 font-weight-light">{title}</h2>
        <Row>
          <Col className="py-2 mb-3" dangerouslySetInnerHTML={{ __html: html }} />
        </Row>

        { results.length && 
        <>
          <h2 className="mb-4 font-weight-light">Results</h2>
          <Row>
            {results}
          </Row>
        </>
        }
      </Container>
    </>
  )
}

export const standardImageFragment = graphql`
  fragment StandardImageFragment on File {
    childImageSharp {
      fluid(maxWidth: 1500) {
        ...GatsbyImageSharpFluid
      }
    }
  }
`

export const standardMarkdownFragment = graphql`
  fragment StandardMarkdownFragment on MarkdownRemark {
    html
    frontmatter {
      title
    }
  }
`

export default StandardPage